import { CampusUnit } from './campus-unit.model';

export class CampusStake extends CampusUnit {
    campusStakeId: number;
}
